import { render, staticRenderFns } from "./nav_item.vue?vue&type=template&id=3de43e2a"
import script from "./nav_item.vue?vue&type=script&lang=js"
export * from "./nav_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports